import React from 'react';
import { PlayArrow, ViewCarousel } from '@material-ui/icons';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import styles from '../../../../constants/styles';
var useStyles = makeStyles(function () {
    return createStyles({
        icon: {
            position: "absolute",
            right: 0,
            color: styles.color.icon,
            minWidth: 10,
        },
    });
});
export var MediaTypeIcon = function (_a) {
    var mediaType = _a.mediaType;
    var styles = useStyles();
    return (React.createElement("div", null,
        mediaType === "video" && React.createElement(PlayArrow, { fontSize: "large", className: styles.icon }),
        mediaType === "carousel_album" && (React.createElement(ViewCarousel, { fontSize: "large", className: styles.icon }))));
};
